<div class="mb-3">
  <div class="d-flex justify-content-between align-items-center">
    <span class="font-weight-bold">
      {{ title }}
    </span>
    <span class="btn btn-link" (click)="isOpen ? close() : open()">{{
      actionMsg
    }}</span>
  </div>
  <div *ngIf="isOpen">
    <div class="mb-3">
      <textarea
        class="form-control w-100"
        type="text"
        placeholder="მიუთითეთ ტექსტი"
        [value]="inputValue"
        (keyup)="onKeyUp($event)"
        [disabled]="isComponentDisabled"
      ></textarea>
    </div>
    <button
      class="btn btn-primary"
      (click)="save()"
      [disabled]="isComponentDisabled"
    >
      შენახვა
    </button>
  </div>
</div>
